import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface CoachListConfirmationDialogData {
	title: string;
	message: string;
}

@Component({
	selector: 'app-reset-seats-confirmation',
	standalone: true,
	imports: [MatDialogModule, MatButtonModule],
	template: `
		<h5 mat-dialog-title>{{ data.title }}</h5>

		<mat-dialog-content [innerHTML]="data.message"></mat-dialog-content>

		<mat-dialog-actions align="end">
			<button type="button" mat-raised-button color="warn" (click)="close(false)">Nie</button>
			<button type="button" mat-raised-button color="primary" (click)="close(true)">Tak</button>
		</mat-dialog-actions>
	`,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CoachListConfirmationComponent {
	readonly data: CoachListConfirmationDialogData = inject(MAT_DIALOG_DATA);

	private readonly dialogRef = inject(MatDialogRef<CoachListConfirmationComponent, boolean>);

	close(result: boolean): void {
		this.dialogRef.close(result);
	}
}
